/**
 * YTB 独立构建入口 — 精简依赖，不引入 Monaco / SCCP / DMG 样式与内网调试工具
 *
 * 由 `npm run build:ytb` (EW_FE_TARGET=ytb) 使用；全量构建仍走 main-app.ts
 */
// >>> EW-RUNTIME-PROBE begin — 须最先装载；移除见 ew-bg/utils/probe/TAG.md
import "@/utils/dev/probe-reporter";
// <<< EW-RUNTIME-PROBE end

import { createApp, h } from "vue";
import { RouterView } from "vue-router";

// Element Plus 组件由 unplugin-vue-components 按需注入；API 样式见下方按需 css
import "element-plus/theme-chalk/dark/css-vars.css";
import "element-plus/es/components/message/style/css";
import "element-plus/es/components/message-box/style/css";

// YTB 主题 + 基础样式（不引入 dmg-dark-theme / sccp / analyze-common 等内网样式）
import "@/assets/css/ytb-theme.css";
import "@/assets/css/app-form-item-text-theme.css";
import "@/assets/css/reset.css";
import "@/assets/css/base.scss";
// 置后加载，配合 !important 压住 EP 按需 el-scrollbar 6px；宽度改 scrollbar.css --ew-scrollbar-bar-size
import "@/assets/css/scrollbar.css";

import router from "./router/index-ytb";
import pinia from "./stores";

const app = createApp({
  render: () => h(RouterView),
});

app.use(pinia);
app.use(router);

import { useThemeStore } from "./stores/modules/theme.store";
const themeStore = useThemeStore();
(themeStore as any).init();

app.mount("#app");
